import React from "react";
import { useSearchParams } from "react-router-dom";
import WardSetup from "./WardSetup";
import OTSetup from "./OTSetup";
import ICUSetup from "./ICUSetup";

const HospitalDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "ward";

  const renderActiveTab = () => {
    switch (activeTab) {
      case "ward":
        return <WardSetup />;
      case "ot":
        return <OTSetup />;
      case "icu":
        return <ICUSetup />;
      default:
        return <WardSetup />;
    }
  };

  const handleTabClick = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto">
        <header className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            Hospital Management Setup
          </h1>
        </header>
        <nav className="flex space-x-4 mb-6">
          <button
            className={`px-4 py-2 rounded-lg font-semibold transition ${
              activeTab === "ward"
                ? "bg-blue-600 text-white"
                : "bg-white text-blue-600 border border-blue-600"
            }`}
            onClick={() => handleTabClick("ward")}
          >
            Ward
          </button>
          <button
            className={`px-4 py-2 rounded-lg font-semibold transition ${
              activeTab === "ot"
                ? "bg-red-600 text-white"
                : "bg-white text-red-600 border border-red-600"
            }`}
            onClick={() => handleTabClick("ot")}
          >
            OT
          </button>
          <button
            className={`px-4 py-2 rounded-lg font-semibold transition ${
              activeTab === "icu"
                ? "bg-green-600 text-white"
                : "bg-white text-green-600 border border-green-600"
            }`}
            onClick={() => handleTabClick("icu")}
          >
            ICU
          </button>
        </nav>
        <main>{renderActiveTab()}</main>
      </div>
    </div>
  );
};

export default HospitalDashboard;
